import React from 'react';
import SponsorShipList from './sponsorship-content/SponsorShipList';
import { tickets } from 'data/weraise-data/sponsored-list-data';

const SponsoredList = () => {
  return (
    <SponsorShipList
      data={tickets}
      title="Sponsored"
      initialLayout="cardview"
    />
  );
};

export default SponsoredList;
